import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export const useSearchQuery = <T extends Record<string, any>>() => {
  const [searchParams, setSearchParams] = useSearchParams();
  const preValue = {} as T;
  const currentPath = window.location.pathname;

  let filterCount = 0;
  searchParams.forEach((value, key) => {
    preValue[key as keyof T] = value as T[keyof T];

    if (key !== 'page' && key !== 'limit' && key !== 'tab' && value !== '' && !key.includes('FilterTitle')) {
      // for example: dataContactFilerTitle will ignore in counting
      filterCount++;
    }
  });

  // if the path is the same, set the search params
  // if the path is different, do nothing
  // to avoid infinite path change loop
  const handleSetSearchParams = (obj: Partial<T>) => {
    if (currentPath === window.location.pathname) {
      setSearchParams({ ...obj } as any, { replace: true });
    }
  };

  return {
    searchParams: preValue,
    setSearchParams: handleSetSearchParams,
    filterCount,
  };
};
